import moment from 'moment/moment';

import { isNil } from '@angular-ru/cdk/utils';

import { PRICE_LIST_OPEN_END_VALIDITY_DATE } from '../constants';
import { PriceListActionType } from '../models/price-list.model';
import { PriceListSubfamilyDetailsEntityData } from '../models/subfamily-price-data.model';

export const PriceListUtils = {
  isFinalizeAction: (action: PriceListActionType) => {
    return action === 'finalize' || action === 'finalizeWarranty' || action === 'finalizeMarkup';
  },
  // APPLYMESD-2794: solo una taglia vuota eredita dalla sottofamiglia; 0 sulla taglia e' un markup non disponibile
  isMarkupInherited: (sizeValue: number | null | undefined, subfamilyValue: number | null | undefined) => {
    return isNil(sizeValue) && !isNil(subfamilyValue);
  },
  // Il markup in vigore per la taglia: 0 e' un valore e si mostra 0%, nessun valore si mostra n.d.
  sizeMarkupValue: (sizeValue: number | null | undefined, subfamilyValue: number | null | undefined) => {
    return isNil(sizeValue) ? subfamilyValue : sizeValue;
  },
  isDeactivateAction: (action: PriceListActionType) => {
    return action === 'deactivate';
  },
  // Fine validita' aperta della revisione in vigore (catena di validita', APPLYMESD-2794): non e' una data da mostrare
  isOpenEndValidityDate: (date: string | number | undefined | null) => {
    return !isNil(date) && moment(date).isSame(PRICE_LIST_OPEN_END_VALIDITY_DATE, 'day');
  },
  isDateWithinValidityPeriod: (
    date: moment.Moment | undefined | null,
    priceListEntityData: PriceListSubfamilyDetailsEntityData | undefined
  ) => {
    if (!priceListEntityData || !date) {
      return false;
    }

    const momentStart = moment(priceListEntityData.startValidityDate).hour(0);
    const momentEnd = moment(priceListEntityData.endValidityDate).hour(0);

    return date.isSameOrAfter(momentStart) && date.isSameOrBefore(momentEnd);
  },
  areValidDraftsPresent: (priceListItems: PriceListSubfamilyDetailsEntityData[] | undefined) => {
    if (!priceListItems) {
      return false;
    }

    return (
      priceListItems.filter(elem => elem.status === 'DRAFT' && moment(elem.startValidityDate).isAfter(moment()))
        .length > 0
    );
  },
  arePriceListEntitiesInvalid: (priceListItems: PriceListSubfamilyDetailsEntityData[] | undefined) => {
    if (!priceListItems) {
      return false;
    }

    return (
      priceListItems.filter(priceListItem => moment(priceListItem.startValidityDate).hour(0).isAfter(moment()))
        .length >= 3
    );
  },
};
